import { styled } from '@mui/material';
import { themeDefaults } from '@youscience/theme';

export const sxStyles = {
  locationField: {
    marginBottom: '1rem',
    backgroundColor: 'white',
  },
  cipCodesWrap: {
    overflowY: 'scroll',
    maxHeight: '552px',
  },
  averageCostSliderWrap: {
    marginTop: '1rem',
    marginBottom: '1rem',
    maxWidth: '240px',
  },
  averageCostTitle: {
    padding: '0 0.5rem',
    fontSize: '0.75rem',
    color: themeDefaults?.palette?.text?.secondary,
  },
  filterSectionTitle: {
    marginBottom: '1.5rem',
    marginLeft: '0.5rem',
  },
  searchWrap: {
    maxWidth: '240px',
    margin: '2rem 0 1.5rem 0',
  },
  clearBtn: {
    display: 'flex',
    margin: '1.5rem 0',
    fontSize: '0.75rem',
    transition: 'background-color 0.5s',

    svg: {
      marginLeft: '0.5rem',
    },
  },
  alertWrap: {
    marginTop: '1.5rem',

    '.MuiAlert-root': {
      maxWidth: '250px',
      minWidth: 'auto',
    },
  },
  selectedValue: {
    margin: '0 0.25rem 0.5rem 0.25rem',
    maxWidth: '255px',
  },
};

export const StyledFilterSectionWrap = styled('form')(({ theme }) => ({
  paddingRight: '0.5rem',
  marginRight: '1rem',
  marginTop: '0.5rem',
  maxWidth: '304px',
  width: '100%',

  [theme.breakpoints.down('md')]: {
    marginRight: 0,
  },

  [theme.breakpoints.down('xs')]: {
    marginLeft: 0,
  },
}));

export const StyledAverageCostTitleWrap = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: '1.5rem',

  '& > div:last-of-type': {
    display: 'flex',

    '&:hover': {
      cursor: 'pointer',
    },
  },
}));
